import RecoverStep from "../recover_step";
import {attachContactSupportHandler, attachRowHandler} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";

const TEMPLATE = 'appliances';

export default class SetAppliance extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        if (!data.recovery) { fr.goTo('type'); }
        data.render = { searchComplete : false, showOffsite : data.restore.type === "cloud", hasNonPF : data.hasNonPF };

        const renderAppliances = function () {
            if (data.appliances.length === 1) {
                data.recovery.appliance_id = data.appliances[0].id;
                fr.goTo('setDevice');
            } else {
                data.render.searchComplete = true;
                fr.render("setAppliance");
            }
        };

        const requestSettings = {
            scopeBy: "CLIENT",
            forClient: data.clientId,
            paging: {offset: 0, limit: 100},
            devices_count: true,
            offsited: data.restore.type === "cloud",
            eligible_for_cifs_sharing: data.restore.type === "appliance"
        };

        if (data.applianceId) {
            requestSettings.scopeBy = "APPLIANCE";
            requestSettings.forAppliance = data.applianceId;
            data.recovery.appliance_id = data.applianceId;
            data.render.hasNonPF = true;
        }

        $.ajax({
            type: "POST",
            url: "/appliance/get",
            data: JSON.stringify(requestSettings),
            success: function (appliances) {
                data.appliances = appliances;
                renderAppliances();
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    postRender(data, el, fr) {
        const $el = $(el);
        if (data.render.searchComplete) {
            attachRowHandler(el);
            attachContactSupportHandler(data, el, fr);
            alignHeaderOnLimitedHeightTable($el);
            $el.find('thead th:eq(1)').click();
        }
        $el.find('tbody tr').on('click', function() {
            const selected_row = $(this);
            data.tmp.previousStep = fr.currentStep;
            data.recovery.appliance_id = selected_row.find('input').val();
            fr.goTo('setDevice');
        });
    }

}
